<template>
    <div>
        <Topnav />
        <div class="content">
            <div class="jumbotron text-center">
                <h2>Contact Us</h2>
                <hr class="bg-dark"/>
                <p>Contacting through email is oudated, we use Telegram to answer you. It is simple, smart and fast.</p>
                
            </div>
           <div class="text-center">
               <div>
                   <p><a href="https://t.me/hackspider" target="blank">Contact Creator</a></p>
               </div>

               <div>
                   <p><a href="https://t.me/Chatbotcreatorbot" target="blank">Report Bug</a></p>
               </div>

               <div>
                   <p><a href="https://t.me/botcreatorchat" target="blank">Ask Question</a></p>
               </div>

               <div>
                   <p><a href="https://t.me/botcreatorchat" target="blank">Request Template</a></p>
               </div>

               <div>
                   <p><a href="https://t.me/TheBotCreatorOfficial" target="blank">Join our Telegram Channel</a></p>
               </div>      
              
          </div>
        </div>
       
    </div>
</template>

<script>
import Topnav from "@/components/Topnav.vue";



export default {
    name: 'ContactUs',
    components:{
        Topnav,
        
    },
    data: function () {
        return{
            botLink: 'https://t.me/Chatbotcreatorbot',
            channel_link: 'https://t.me/TheBotCreatorOfficial',
            group_link: 'https://t.me/botcreatorchat',
            creator_link: 'https://t.me/hackspider'
        }
        
    }
}
</script>